import Choices from 'choices.js';

export default (form) => {
    const selects = Array.from(form.querySelectorAll('select'));

    selects.forEach((select) => {
        select.parentNode.classList.add('select-wrapper'); 

        // Only init choices for multiple selects
        if (select.multiple) {
            new Choices(select, {
                searchEnabled: false,
                itemSelectText: '',
            });
        }
    });
};
